module.exports = __webpack_public_path__ + "img/LIP.ebf9123f.png";